import React from 'react';

import cn from 'classnames';

import bem from 'client/services/bem';

import {RADIO_COLORS} from 'client/common/inputs/radio-input/constants';

import {RadioInputColors} from './types';

import './radio-input.scss';

const b = bem('radio-input');

type Props = {
  label?: React.ReactNode;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  value: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  color?: RadioInputColors;
  asButton?: boolean;
};

const RadioInput: React.FC<Props> = (props) => {
  const {
    label = '',
    name = '',
    checked = false,
    disabled = false,
    value,
    onChange,
    className,
    color = 'primary',
    asButton = false,
    ...radioInputProps
  } = props;

  return (
    <label
      className={cn(
        b({
          disabled: disabled,
          checked: checked,
          'is-button': asButton,
          [color]: color,
        }),
        className,
      )}
    >
      <input
        type="radio"
        name={name}
        disabled={disabled}
        className={b('input')}
        value={value}
        checked={onChange && checked}
        defaultChecked={!onChange && checked}
        onChange={onChange}
        {...radioInputProps}
      />
      {!asButton && (
        <div
          className={b('visual', {
            [color]: color,
            checked: checked,
            disabled: disabled,
          })}
        />
      )}
      {label && <span className={b('label')}>{label}</span>}
    </label>
  );
};

export {RADIO_COLORS, type RadioInputColors};

export default RadioInput;
